"use strict";
export const initSwiper = async (selector) => {
    const firstElement = document.querySelector(selector);
    if (!firstElement) return;
	try {
        const module = await import('../modules/swiper');
        module.initSwiper(selector);
	} catch (error) {
		console.error("Failed to load Swiper dynamically:", error);
		return;
	}
}